import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

export const loginUrlMap = {
  yourself: () => `${PREFIX.vapis(GROUPS.iam)}/yourself`,
  loginOut: () => `${PREFIX.oauth}/logout`,
};

export function yourself() {
  return get(`${loginUrlMap.yourself()}`);
}

export function loginOut() {
  return get(`${loginUrlMap.loginOut()}`);
}
